let Stickers = {
    updating: false,
    update: function(season_id) {
        if (!Stickers.updating) {
            Stickers.updating = true;
            let container = document.getElementById(`stickers_data_${season_id}`);
            let status = container.dataset.status;

            if (status==="disabled") {
                container.setAttribute('data-status', 'enabled');
                container.classList.remove('stickers_hide');
            } else {
                container.setAttribute('data-status', 'disabled');
                container.classList.add('stickers_hide');
            }
            Stickers.updating = false;
        } else {
            Alert.push([{type: 'danger', text: '¡Espera! Estamos procesando una petición previa tuya.', icon: 'triangle-alert'}]);
        }
    },
}
